export const getRingStyle = (color, borderRadius = 'full', darkColor = color)=>({
        _before: {
            border: '2px solid transparent',
            content: '""',
            position: 'absolute',
            borderColor: color,
            borderRadius,
            bottom: `-4px`,
            left: `-4px`,
            right: `-4px`,
            top: `-4px`,
            _dark: {
                color: darkColor
            }
        },
        boxShadow: 'none'
    });
export const cancelRingStyle = ()=>({
        _before: {
            border: 'none'
        },
        boxShadow: 'outline'
    });

//# sourceMappingURL=getRingStyle.js.map